var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYtShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 10.0007L10.1263 8.00065L6.66634 6.00065V10.0007ZM14.373 4.78065C14.4597 5.09398 14.5197 5.51398 14.5597 6.04732C14.6063 6.58065 14.6263 7.04065 14.6263 7.44065L14.6663 8.00065C14.6663 9.46065 14.5597 10.534 14.373 11.2207C14.2063 11.8207 13.8197 12.2073 13.2197 12.374C12.9063 12.4607 12.333 12.5207 11.453 12.5607C10.5863 12.6073 9.79301 12.6273 9.05967 12.6273L7.99967 12.6673C5.20634 12.6673 3.46634 12.5607 2.77967 12.374C2.17967 12.2073 1.79301 11.8207 1.62634 11.2207C1.53967 10.9073 1.47967 10.4873 1.43967 9.95398C1.39301 9.42065 1.37301 8.96065 1.37301 8.56065L1.33301 8.00065C1.33301 6.54065 1.43967 5.46732 1.62634 4.78065C1.79301 4.18065 2.17967 3.79398 2.77967 3.62732C3.09301 3.54065 3.66634 3.48065 4.54634 3.44065C5.41301 3.39398 6.20634 3.37398 6.93967 3.37398L7.99967 3.33398C10.793 3.33398 12.533 3.44065 13.2197 3.62732C13.8197 3.79398 14.2063 4.18065 14.373 4.78065Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtShort);
export default __webpack_public_path__ + "static/media/yt-short.bfca63036498a814f7a70c65bac82a0e.svg";
export { ForwardRef as ReactComponent };